import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-unity',
  templateUrl: './login-unity.component.html',
  styleUrls: ['./login-unity.component.scss'],
})
export class LoginUnityComponent implements OnInit {
  title = 'app-login-unity';

  ngOnInit(): void {}
}
